import axios from 'axios';
import type { RefreshResponse } from '../auth/types';
import { userStore } from '@/lib/stores/user.store';

export const baseURL = process.env.NEXT_PUBLIC_API;

export const api = axios.create({
  baseURL,
  timeout: 100000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
  withXSRFToken: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access-token');
    if (token) config.headers.authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (config) => config,
  async (error) => {
    const original = error.config;
    if (error?.response?.status == 401 && error.config && !error.config._isRetry) {
      original._isRetry = true;
      try {
        const response = await axios.get<RefreshResponse>(
          `${process.env.NEXT_PUBLIC_API}/auth/refresh`,
          { withCredentials: true },
        );
        localStorage.setItem('access-token', response.data.result);
        return api.request(original);
      } catch {}
    }
    if (error?.response?.status === 401 || error?.response?.status === 403) userStore.delete();
    throw error;
  },
);

export function useApi() {
  return { api };
}
